import { render, staticRenderFns } from "./ArticleExternal.vue?vue&type=template&id=426b4eff&scoped=true"
import script from "./ArticleExternal.vue?vue&type=script&lang=js"
export * from "./ArticleExternal.vue?vue&type=script&lang=js"
import style0 from "./ArticleExternal.vue?vue&type=style&index=0&id=426b4eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b4eff",
  null
  
)

export default component.exports